export {
  BubbleBackground,
  type BubbleBackgroundProps,
} from './components/backgrounds/bubble'
